import {ModuleComponent} from "../../js/module-component";

export class ModInternalHeader extends ModuleComponent{
    ready(){
        super.ready();

        let me = this.$root;
        let mescope = this.scope;

        function checkScroll($mod){
            /*Header blanco*/
            var scroll = $(window).scrollTop();
            me.toggleClass("is-white is-small",scroll>=1);
            me.find(mescope+"__user-btn-a").toggleClass("o-button--outline",scroll>=1).toggleClass("o-button--outline-secondary",scroll<1);
        }

        me.find(mescope+"__opener").click((ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            me.find(mescope+"__mobile-menu").toggleClass("is-opened");
            $("body").toggleClass("u-no-scroll");
            me.find(mescope+"__main-menu").toggleClass("is-opened");
            $(".js-mod-private-zone-header__main-menu").toggleClass("is-opened");
        });
        me.find(mescope+"__main-menu-a").click(function(ev){
            me.find(mescope+"__opener:visible").click();
        });
        $(window).scroll(function(){
            checkScroll(me);
        });
        checkScroll(me);

    }
}
